import React from 'react';
import {
  LegalPageLayout,
  SectionTitle,
  Paragraph,
  List,
  ListItem,
  Strong,
} from '../components/LegalPageLayout';

const RefundPolicy: React.FC = () => (
  <LegalPageLayout
    title="Return & Refund Policy"
    updatedOn="30 January 2025"
  >
    <Paragraph>
      Thank you for shopping at Phinative Soft Private Limited. The following
      terms are applicable for any products that you have purchased from us.
    </Paragraph>

    <SectionTitle>Eligibility for Refunds</SectionTitle>
    <Paragraph>We offer refunds under the following circumstances:</Paragraph>
    <List>
      <ListItem>
        If the service is not delivered as promised due to an error on our end.
      </ListItem>
      <ListItem>
        If a technical issue caused by our platform prevents you from accessing
        the features you paid for, and the issue cannot be resolved within a
        reasonable timeframe.
      </ListItem>
      <ListItem>
        If you cancel your subscription within the refund period outlined below.
      </ListItem>
    </List>

    <SectionTitle>Refund Period</SectionTitle>
    <Paragraph>
      Refund requests must be made within 30 days of the payment date. Requests
      made after this period will not be eligible for a refund.
    </Paragraph>

    <SectionTitle>Non-Refundable Cases</SectionTitle>
    <Paragraph>Refunds will not be granted under the following conditions:</Paragraph>
    <List>
      <ListItem>
        If you change your mind after purchasing a subscription or service.
      </ListItem>
      <ListItem>
        If you fail to use the service during the subscription period.
      </ListItem>
      <ListItem>
        If the issue is caused by third-party software or tools not affiliated
        with our platform.
      </ListItem>
    </List>

    <SectionTitle>Refund Process</SectionTitle>
    <Paragraph>To request a refund, please follow these steps:</Paragraph>
    <List>
      <ListItem>
        Contact our support team at <Strong>contact@21n.org</Strong>.
      </ListItem>
      <ListItem>
        Provide your payment receipt, order ID, and a detailed explanation of
        the issue.
      </ListItem>
      <ListItem>
        Our team will review your request and respond within 3–5 business days.
      </ListItem>
      <ListItem>
        If your request is approved, the refund will be processed to your
        original payment method within 7–10 business days. This policy content
        has been generated by dodopayments.com.
      </ListItem>
    </List>

    <SectionTitle>Contact Us</SectionTitle>
    <Paragraph>
      If you have any questions about this Refund Policy or require assistance,
      please reach out to us at <Strong>contact@21n.org</Strong>.
    </Paragraph>
  </LegalPageLayout>
);

export default RefundPolicy;

